import { render, staticRenderFns } from "./shiti.vue?vue&type=template&id=38fc1500&scoped=true&"
import script from "./shiti.vue?vue&type=script&lang=js&"
export * from "./shiti.vue?vue&type=script&lang=js&"
import style0 from "./shiti.vue?vue&type=style&index=0&id=38fc1500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc1500",
  null
  
)

export default component.exports